var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('img',{staticClass:"my-auto",attrs:{"src":_vm.imgDetails[0],"alt":_vm.imgDetails[1],"height":"15"}}),_vm._v(" "),(_vm.tooltipText)?_c('TooltipIcon',{staticClass:"ml-2 d-inline-block my-auto",attrs:{"tooltip-text":_vm.tooltipText,"tooltip-id":_vm.tooltipId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }